import esbuild from 'esbuild';
import { readFile } from 'node:fs/promises';
import path, { join } from 'node:path';
import { getBackendCJSDir } from '@wix/cli-app-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function optimizeCjsDependency({
  url,
  projectFolder,
}: {
  url: string;
  projectFolder: string;
}) {
  const tmpDir = getBackendCJSDir(projectFolder);

  const { metafile } = await esbuild
    .context({
      absWorkingDir: projectFolder,
      entryPoints: [url],
      bundle: true,
      platform: 'browser',
      format: 'esm',
      target: 'esnext',
      logLevel: 'error',
      splitting: true,
      outdir: tmpDir,
      ignoreAnnotations: true,
      metafile: true,
      external: ['node:*', '@wix/sdk', '@wix/sdk/*'],
      charset: 'utf8',
    })
    .then((context) => context.rebuild())
    .catch((error: unknown) => {
      throw new CliError({
        code: CliErrorCode.FailedOptimizingWithEsbuild(),
        cause: error,
      });
    });

  const [output] =
    Object.entries(metafile.outputs).find(
      ([, output]) =>
        output.entryPoint &&
        path.resolve(projectFolder, output.entryPoint) === path.resolve(url)
    ) ?? [];

  if (!output) {
    throw new CliError({
      code: CliErrorCode.FailedToFindEsbuildOutputFile(),
      cause: null,
    });
  }

  return readFile(join(projectFolder, output), 'utf-8').catch(
    (error: unknown) => {
      throw new CliError({
        code: CliErrorCode.FailedReadingEsbuildOutputFile(),
        cause: error,
      });
    }
  );
}
